import InterBold from 'assets/fonts/Inter/Inter-Bold.ttf';
import InterMedium from 'assets/fonts/Inter/Inter-Medium.ttf';
import InterRegular from 'assets/fonts/Inter/Inter-Regular.ttf';
import InterSemiBold from 'assets/fonts/Inter/Inter-SemiBold.ttf';
import StabilGroteskBold from 'assets/fonts/StabilGrotesk/StabilGrotesk-Bold.otf';
import StabilGroteskBoldItalic from 'assets/fonts/StabilGrotesk/StabilGrotesk-BoldItalic.otf';
import StabilGroteskMedium from 'assets/fonts/StabilGrotesk/StabilGrotesk-Medium.otf';

export default `
  @font-face {
    font-family: StabilGrotesk;
    font-weight: 500;
    src: url(${StabilGroteskMedium}) format('opentype');
    font-display: block;
  }

  @font-face {
    font-family: StabilGrotesk;
    font-weight: 600;
    src: url(${StabilGroteskBold}) format('opentype');
    font-display: block;
  }

  @font-face {
    font-family: StabilGrotesk;
    font-weight: 600;
    font-style: italic;
    src: url(${StabilGroteskBoldItalic}) format('opentype');
    font-display: block;
  }

  @font-face {
    font-family: Inter;
    font-weight: 700;
    src: url(${InterBold}) format('truetype');
    font-display: block;
  }

  @font-face {
    font-family: Inter;
    font-weight: 500;
    src: url(${InterMedium}) format('truetype');
    font-display: block;
  }

  @font-face {
    font-family: Inter;
    font-weight: 400;
    src: url(${InterRegular}) format('truetype');
    font-display: block;
  }

  @font-face {
    font-family: Inter;
    font-weight: 600;
    src: url(${InterSemiBold}) format('truetype');
    font-display: block;
  }
`;
